import { render, staticRenderFns } from "./salesComponent.vue?vue&type=template&id=60b1eaa4&scoped=true"
import script from "./salesComponent.vue?vue&type=script&lang=js"
export * from "./salesComponent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "60b1eaa4",
  null
  
)

export default component.exports